// Lightweight, privacy-friendly visit ping for the Ops-Console geo map.
// Fire-and-forget POST to the backend, which records the visitor's country
// (from CloudFront) — no cookies, no IDs, no third-party scripts. Failures are
// swallowed so a tracking hiccup never affects the app.
export function trackVisit() {
  try {
    const url = `${import.meta.env.VITE_API_URL || ''}/api/geo/visit`
    fetch(url, { method: 'POST', keepalive: true }).catch(() => {})
  } catch {
    /* no-op */
  }
}

// Business-event ping for the Keelara Council engagement-depth fanout. Same
// privacy posture as trackVisit — no cookies, no IDs, just an anonymous count
// of a key user action. The allowlist mirrors the backend's ALLOWED_EVENTS so
// a typo here never sprays an unrecognised name at the API. Fire-and-forget.
export const COUNCIL_EVENTS = Object.freeze([
  'document_processed', // a document finished extraction successfully
  'signup',             // a Cognito account was confirmed
  'pro_upgrade',        // a user moved from free to a paid tier
])

export function trackEvent(eventName) {
  try {
    if (!COUNCIL_EVENTS.includes(eventName)) return
    const url = `${import.meta.env.VITE_API_URL || ''}/api/event`
    fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: eventName }),
    }).catch(() => {})
  } catch {
    /* no-op */
  }
}
